import { AppError, AppErrorSerialised } from './AppError';
import type { AppErrorType } from './AppErrorType';
import { isNetworkError } from './utils';

export type ThrowExtras = {
  cause?: unknown;
  type?: AppErrorType;
  data?: Record<string, unknown>;
};

export function throwError(code: string, message: string, extra?: ThrowExtras): never {
  throw createError(code, message, extra);
}

export function createError(code: string, message: string, extra?: ThrowExtras): AppError {
  return new AppError({
    code,
    data: extra?.data,
    type: extra?.type ?? (isNetworkError(extra?.cause) ? 'Network' : 'General'),
    message,
    cause: extra?.cause,
  });
}

export function createErrorFromSerialised(serialised: AppErrorSerialised): AppError {
  return new AppError({
    code: serialised.code,
    message: serialised.message,
    type: serialised.type,
    data: serialised.data ? JSON.parse(serialised.data) : undefined,
    cause: serialised.cause ? JSON.parse(serialised.cause) : undefined,
  });
}
